<template>
  <div id="app">
    <template v-if="layout">
      <component :is="layout">
        <router-view />
      </component>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { ApiClient } from './helpers/api-client/ApiClient';

export default {
  computed: {
    layout () {
      if (this.$route.meta.layout === false) {
        return null
      }

      return this.$route.meta.layout || process.env.VUE_APP_DEFAULT_LAYOUT
    }
  },

  beforeMount () {
    ApiClient.configurationData().then((response) => {
      this.$store.commit('setConfiguration', response.data.data.configuration)
    })
  }
}
</script>
